import { render, staticRenderFns } from "./AttachmentsModal.vue?vue&type=template&id=5256eaee&scoped=true&"
import script from "./AttachmentsModal.vue?vue&type=script&lang=ts&"
export * from "./AttachmentsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentsModal.vue?vue&type=style&index=0&id=5256eaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5256eaee",
  null
  
)

export default component.exports